export const normalizeQuickFilterText = (value) => {
    if (value === null || value === undefined) return "";

    return value
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
};

export const buildAccentInsensitiveColDef = (colDef = {}) => ({
    ...colDef,
    getQuickFilterText: colDef.getQuickFilterText
        ? (params) => normalizeQuickFilterText(colDef.getQuickFilterText(params))
        : (params) => normalizeQuickFilterText(params.value),
});

export const setAccentInsensitiveQuickFilter = (gridRef, value) => {
    gridRef.current?.api?.setGridOption(
        "quickFilterText",
        normalizeQuickFilterText(value),
    );
};
